module.exports = __webpack_public_path__ + "static/media/TalkRemit.4718ef07.svg";